import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { getSbPosition, selectClipData } from 'components/app/_helpers/_app.helper';
import { Error } from 'components/app/_helpers/app-errors.helper';
import { ClipsMap, LinkedClips, handleClips } from 'components/app/editor/_mediator/editor.slice';
import { setSbPosition } from 'components/app/editor/_mediator/editor-controls.slice';
import { isLinksValid } from './editor-clips-linking.helper';
import { clipsApi, linksApi } from './editor-clips.helper';
import { handleSbLinks } from './editor-clips-sb.helper';

export const useClipsDelete = () => {
  const { path } = useLocation();
  const { clipsMap, selector, linkedClips, storyBoard } = useAppSelector((state) => state.editor);
  const dispatch = useAppDispatch();

  const handleLonelyLinkedClips = (linkedClips: LinkedClips, clipsMap: ClipsMap) => {
    const clipIds: ClipId[] = [];
    Object.values(linkedClips).forEach((group) => {
      if (group.length !== 1) return;
      clipIds.push(group[0]);
    });
    if (!clipIds.length) return;
    const clips = clipIds.map((clipId) => selectClipData(clipId, clipsMap));
    return linksApi(linkedClips).unlink(clips);
  };

  return (clipId: ClipId) => {
    if (!clipsMap || !selector) return;

    if (path === Path.selector) dispatch(setSbPosition(getSbPosition(clipId, storyBoard)));

    const clip = selectClipData(clipId, clipsMap);
    const res = clipsApi(selector, storyBoard, linkedClips).del([clip], true);

    if (!isLinksValid(res.linkedClips)) {
      Error.linkingNotPossible();
      return;
    }
    const res1 = handleSbLinks(res.linkedClips, res.storyBoard, storyBoard);
    if (res1.status === 'cantBeFixed') {
      Error.handleSbLinks();
      return;
    }
    const res2 = handleLonelyLinkedClips(res.linkedClips, clipsMap);

    dispatch(
      handleClips({
        data: {
          selector: res.selector,
          storyBoard: res1.storyBoard,
          linkedClips: res2?.linkedClips ?? res.linkedClips,
          clipsMap: res2 ? { ...res.clipsMap, ...res2.clipsMap } : res.clipsMap,
        },
        backupParams: { title: 'Delete Clip', action: 'delClip', activeClip: [clipId, null] },
      })
    );
  };
};
